export class EquipmentLocation {
    ID?: number;
    EquipmentLocation: string;
}

export default EquipmentLocation;